import React from 'react';

const NotAuthorizedCard = () => {
    return (
        <div className="card shadow-sm m-4 p-4 text-center">
            <h5 className="mt-3 mb-3">Only full-time employees are authorized to use this feature</h5>
        </div>
    );
};

export default NotAuthorizedCard;
